export class GoogleDirection {
  public lat: number = 0;
  public long: number = 0;
}
